import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import { DEFAULT_LANGUAGE } from './types';
const LanguageContext = createContext({
    language: DEFAULT_LANGUAGE,
    setLanguage: () => { },
});
export function LanguageProvider({ initialLanguage = DEFAULT_LANGUAGE, children, }) {
    const [language, setLanguage] = useState(initialLanguage);
    const value = useMemo(() => ({ language, setLanguage }), [language]);
    return _jsx(LanguageContext.Provider, { value: value, children: children });
}
export function useLanguage() {
    return useContext(LanguageContext);
}
